import React, { useState } from "react";
import { Grid, Button, TextField, Container, Hidden  } from "@material-ui/core";
import WebStyles from "../../WebStyles.module.css";
import clsx from "clsx";
import HomeWebForm from "../home/HomeWebForm";

function InfoSection({
  xlUp,
  mdUp,
  mdDown,
  smDown,
  xsDown,
  setShowWaitListForm,
}) {
  return (
    <Grid container item xs={12} md={12} alignContent="center">
      <Grid item xs={12}>
        <Grid
          align="center"
          className={clsx(WebStyles.samonHeaderTxt, WebStyles.hankrndFont)}
          style={{
            fontSize: xlUp ? 80 : mdUp ? 60 : 40,
            lineHeight: 1,
            marginBottom: mdUp ? 24 : 12,
            fontWeight: 600,
          }}
        >
          What is Souqh?
        </Grid>
     
      </Grid>
      <Grid item xs={12}>
      <Grid
          align="left"
          className={clsx(WebStyles.paraBlackText, WebStyles.barlowFont)}
          style={{
            fontSize: mdUp ? 22 : 18,
            // lineHeight: 1,
            marginBottom: xlUp ? 24 : mdUp ? 20 : 10,
          }}
        >
          Looking for a plumber online in Canada? Souqh filters your search by location and gives a short list of plumbers that you can compare based on their experience, services, average response time, and reviews by past clients. Find a trustable local plumber today.

<br/>
<br/>
        </Grid>
      </Grid>
     
      {/* <Grid item xs={12} md={6} style={{ marginTop: mdUp ? 20 : 10 }}>
      <TextField fullWidth placeholder="Your email"></TextField>
    </Grid> */}
    <Grid
     container
     item
     xs={12}
     md={12}
     align="center"
     alignContent="center">
       <Grid item container xs={12}>
       <Grid xs={12}>
       <Button
          style={{
            backgroundColor: "#F37C61",
            color: "#FFFFFF",
            textTransform: "none",
            borderRadius: mdUp ? 24 : 12,
            marginTop: smDown ? 20 : 0,
            marginBottom: smDown ? 20 : 10,
            // marginLeft: lgUp ? 20 : 0,
            fontSize: mdUp ? 20 : 14,
            padding: "8px 24px",
            marginRight: xsDown ? 24 : 10,
            marginLeft: xsDown ? 24 : 10,
            width:"auto"
           
          }}
          onClick={() => {
                       window.open("https://app.souqh.ca/");
          }}
        >
          <Grid className={WebStyles.hankrndFont}>Sign up now for free!</Grid>
        </Button>
       </Grid>
     
       </Grid>
     </Grid>
      
    </Grid>
  );
}

function ImageSection({
  xlUp,
  mdUp,
  mdDown,
  smDown,
  xsDown,})
  {
  return (
    
    <Grid item xs={12} md={12}
    style={{
      
      marginTop: mdUp ? 24 : 12,
    }}
    >
      {
        <iframe width="100%" height="450" src="https://www.youtube.com/embed/f_gb6_f0iig" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      /* <img
       src="/images/real_estate_agent/good-agent.jpg"
        style={{
          // height: xlUp ? 625 : mdUp ? 313 : 219,
          width: "100%",
        }}
      /> */}
    </Grid>
  );
}

function IntroductionHomeBuyer({
  smUp,
  smDown,
  mdUp,
  mdDown,
  lgUp,
  xlUp,
  commonPadding,
}) {
  const [showWaitListForm, setShowWaitListForm] = useState(false);
  const handleClose = () => {
    setShowWaitListForm(false);
  };
  return (
    <Grid
      item
      container
      xs={12}
      style={{
        // backgroundImage: lgUp
        //   ? "url('/images/home_buyers/Green patch.svg')"
        //   : "none",
        // backgroundRepeat: "no-repeat",
        // backgroundSize: "10%",
        padding: commonPadding,
      }}
    >

      <Container>
        <Container>
            
              <Grid container direction="row">
                <InfoSection
                  xlUp={xlUp}
                  mdUp={mdUp}
                  mdDown={mdDown}
                  smDown={smDown}

                />
                <ImageSection
                  xlUp={xlUp}
                  mdUp={mdUp}
                  mdDown={mdDown}
                  smDown={smDown}

                />
                
               
              </Grid>
            

           </Container>
      </Container>
    </Grid>
  );
}

export default IntroductionHomeBuyer;
